<template>
  <div>
    <v-btn
      v-if="joboffer.pitchYouApplyUrl"
      :href="joboffer.pitchYouApplyUrl"
      :block="blockButtons || $vuetify.breakpoint.smAndDown"
      target="_blank"
      class="mr-2 px-6 whatsapp-button mb-2 mb-md-2"
      :class="{ 'mb-md-4': blockButtons }"
      @click="trackCta(joboffer.jobofferId, 'pitchyou')"
    >
      <div class="whatsapp-icon">
        <img src="@/assets/icons/whatsapp.png" alt="" aria-hidden="true" />
      </div>
      <span
        class="ml-2"
        v-if="
          !dense ||
          $vuetify.breakpoint.mdAndDown ||
          (blockButtons && $vuetify.breakpoint.lgAndUp)
        "
        :disabled="applicationDisabledMode"
      >
        Mit WhatsApp bewerben
      </span>
    </v-btn>

    <v-btn
      v-if="joboffer.hasExternalApplicationForm"
      class="mb-2 mb-md-2 mr-2"
      :href="joboffer.applyUrl"
      :block="blockButtons || $vuetify.breakpoint.smAndDown"
      :class="{ 'mb-md-4': blockButtons }"
      :disabled="applicationDisabledMode"
      target="_blank"
      @click="trackCta(joboffer.jobofferId, 'external_url')"
    >
      {{ $t('jobs.applyNow') }}
    </v-btn>

    <apply-dialog
      v-else-if="joboffer.hasShortApplicationForm"
      ref="applyDialog"
      :joboffer="joboffer"
      :block="blockButtons || $vuetify.breakpoint.smAndDown"
      :disabled="applicationDisabledMode"
      inlineButton
    />

    <v-btn
      v-else
      class="mb-2 mb-md-2 mr-2"
      :to="{ name: 'apply', params: { jobofferId: joboffer.jobofferId } }"
      :block="blockButtons || $vuetify.breakpoint.smAndDown"
      :class="{ 'mb-md-4': blockButtons }"
      :disabled="applicationDisabledMode"
      @click="trackCta(joboffer.jobofferId, 'normal_form')"
    >
      {{ $t('jobs.applyNow') }}
    </v-btn>

    <template v-if="hasLinkToJobportal">
      <v-btn
        v-if="!customLinkToJobportal || customLinkToJobportal === ''"
        class="mb-2 mb-md-2"
        :to="{ name: 'jobs' }"
        :block="blockButtons || $vuetify.breakpoint.smAndDown"
      >
        {{ $t('jobs.moreJoboffers') }}
      </v-btn>

      <v-btn
        v-else
        class="mb-2 mb-md-2"
        target="_blank"
        :href="customLinkToJobportal"
        :block="blockButtons || $vuetify.breakpoint.smAndDown"
      >
        {{ $t('jobs.moreJoboffers') }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import applyDialog from '@/components/application/apply-dialog.vue';
import TrackingService from '@/services/TrackingService.js';

export default {
  props: {
    joboffer: {
      type: Object,
      required: true
    },

    dense: {
      type: Boolean,
      required: false,
      default: false
    },

    blockButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState('companyModule', {
      hasLinkToJobportal: 'hasLinkToJobportal',
      customLinkToJobportal: 'customLinkToJobportal'
    }),

    applicationDisabledMode() {
      return process.env.VUE_APP_DISABLE_APPLY === 'true';
    }
  },

  methods: {
    openApplyDialog() {
      this.$refs.applyDialog.open();
    },

    trackCta(jobId, ctaType) {
      TrackingService.trackApplyCta(jobId, ctaType);
    }
  },

  components: {
    applyDialog
  }
};
</script>
